import ColumnSettings from "./ColumnSettings";
export default ColumnSettings;
